import React, { createContext, useReducer } from 'react'
import { USER_SIGNIN, PASSLIST_REFRESH, PASSLIST_ADD, PASSLIST_UPDATE, LOGOUT_USER } from './constants'

const initialStateApp = {
    user: {
        email: ''
    },
    passwordManagement: {
        loading:false,
        error:'',
        status: 'update',
        add: false,
        update: false,
        collections: [],
        searchCollection: false,
        pass:null
    },
}

const store = createContext(initialStateApp)
const { Provider } = store

const ContextProvider = ({ children }) => {
    const[state, dispatch] = useReducer((state,actions) => {
        switch (actions.type) {
            case USER_SIGNIN:
                return{
                    ...state,
                    user : {
                        ...state.user,
                        email: actions.email
                    }
                }
            case LOGOUT_USER:
                return{
                    ...state,
                    user : {
                        ...state.user,
                        email: ''
                    },
                    passwordManagement: {
                        ...state.passwordManagement,
                        loading:false,
                        error:'',
                        add: false,
                        update: false,
                        collections: [],
                        searchCollection: false,
                        pass:null                
                    }
                }
            case 'PASSLIST_LOADING':
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        loading: actions.status
                    }
                }
            case 'PASSLIST_ERROR':
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        error: actions.message
                    }
                }
            case PASSLIST_REFRESH:
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        collections: actions.listPass,
                        searchCollection: false
                    }
                }
            case PASSLIST_ADD:
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        status: 'add',
                        update: false,
                        pass: null
                    }
                }
            case PASSLIST_UPDATE:
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        status: 'update',
                        update: true,               
                        pass: actions.pass
                    }
                }
            case 'PASSLIST_NONE':
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        pass: null
                    }
                }
            case 'PASSLIST_SEARCH':
                return{
                    ...state,
                    passwordManagement : {
                        ...state.passwordManagement,
                        searchCollection: actions.listSearch
                    }
                }
            default: return state
        }
    }, initialStateApp )
    
    return <Provider value={{ state, dispatch }} >{ children }</Provider> 
}

export { store, ContextProvider }